import Base from 'app/models/base';

export default Base.extend({
  defaults: {
    readable: '',
    route: '',
    isSubItem: false,
    aclField: '',
  },

  initialize() {},
});



// WEBPACK FOOTER //
// ./app/models/account_nav_item.js